import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { Box, Container, Skeleton } from '@mui/material';

import Hidden from '../../DesignSystem/Hidden';

function PostSkeleton() {
  return (
    <Box
      sx={(theme: any) => ({
        bgcolor: theme.palette.grey[50],
        pb: 5,
      })}
    >
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="rectangular" width="100%" height={450} />
      </Box>

      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 9 }}>
            <Skeleton variant="rectangular" height={600} width="100%" />
          </Grid>
          <Hidden breakpoint="md" direction="down">
            <Grid size={{ md: 3 }}>
              <Skeleton variant="rectangular" height={300} width="100%" />
            </Grid>
          </Hidden>
        </Grid>
      </Container>
    </Box>
  );
}

export default PostSkeleton;
